/**
 * ETL服务器配置api接口
 * @author： xuyd
 * @date：2022-01-12
 */
import request from "@/utils/request.js"

import {context} from '@/config/env.js'

const serviceModule = context.sunflower

export default {

  /**
   * 列表检索
   * @param params
   */
  selectFtpList: (params) => {
    return request.post(serviceModule + "/remote/ftp/searchList", params);
  },

  /**
   * 保存
   * @param params
   */
  saveFtp: (params) => {
    return request.post(serviceModule + "/remote/ftp/save", params);
  },

  /**
   * 删除
   * @param id
   */
  deleteFtp: (id) => {
    return request.post(serviceModule + "/remote/ftp/delete?id=" + id);
  },

  /**
   * 连通性测试
   * @param params
   */
  validateConn: (params) => {
    return request.post(serviceModule + "/remote/ftp/validateConn", params);
  },

}
